function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Reseller",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop---multicard-selection",
  transform: "translate(-534.000000, -716.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M551.5,728 L546,728 L546,733.5 C546,733.776 545.776,734 545.5,734 C545.224,734 545,733.776 545,733.5 L545,728 L539.5,728 C539.224,728 539,727.776 539,727.5 C539,727.224 539.224,727 539.5,727 L545,727 L545,721.5 C545,721.224 545.224,721 545.5,721 C545.776,721 546,721.224 546,721.5 L546,727 L551.5,727 C551.776,727 552,727.224 552,727.5 C552,727.776 551.776,728 551.5,728 M545.5,716 C539.148,716 534,721.148 534,727.5 C534,733.852 539.148,739 545.5,739 C551.852,739 557,733.852 557,727.5 C557,721.148 551.852,716 545.5,716",
  id: "Fill-1"
})));

function SvgWhitePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/whitePlus.92fc3442.svg";
export { ForwardRef as ReactComponent };